import '../scss/testimonials-section.style.scss'
import { useTranslation } from "react-i18next";
import { testimonialsReview } from '../constant/testimonials.constant';
import useMediaQuery from '@mui/material/useMediaQuery';
import { LOCALES } from "../../common/constants";

const ReviewSection = () => {
  const { t } = useTranslation();
  const isDesktop = useMediaQuery('(min-width: 1440px)');

  return (
    <div className="container container-dynamic padding-180">
            <div className='flex-column align-items-start align-items-sm-center justify-content-start justify-content-sm-center d-flex'>
        <h2 className='Heading_h2 mb-sm-0 text-sm-center text-start feature-invoice-title mb-3 '
        >
          {t('TESTIMONIALS_HEADING')}
        </h2>
        <h6 className='text-sm-center text-start mt-3  w-sm-100' style={{ fontSize: '16px', color: '#414651' }}>
          {t('TESTIMONIALS_SUBHEADING')} {isDesktop &&  <br />}
          { t('TESTIMONIALS_SUBHEADING_2') }
        </h6>
      </div>
      <div
        className="trustpilot-widget my-4"
        data-locale={LOCALES.SV_SE}
        data-template-id="54ad5defc6454f065c28af8b"
        data-businessunit-id="64f712e3dbd20bbfcf3a825f"
        data-style-height="240px"
        data-style-width="100%"
        data-theme="light"
        data-stars="5"
        data-review-languages="sv"
      >
        <a
          href="https://se.trustpilot.com/review/invozio.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          Trustpilot
        </a>
      </div>
      <div
        className="trustpilot-widget my-4"
        data-locale={LOCALES.SV_SE}
        data-template-id="5406e65db0d04a09e042d5fc"
        data-businessunit-id="64f712e3dbd20bbfcf3a825f"
        data-style-height="28px"
        data-style-width="100%"
        data-theme="light"
      >
        <a
          href="https://se.trustpilot.com/review/invozio.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          Trustpilot
        </a>
      </div>
    </div>
  );
};

export default ReviewSection;
